import BaseUpload from './base-upload';

function FileUploadService(url, file){
    return BaseUpload(url, file);
}

export default FileUploadService;